import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import { readableColor } from 'polished';
import { Select } from 'chakra-react-select';
import { useTheme } from '@chakra-ui/react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const MultiSelect = _ref => {
  let {
    title,
    name,
    options,
    onChangeFilter
  } = _ref;
  const chakraTheme = useTheme();
  return ___EmotionJSX(Select, {
    "aria-label": title,
    isMulti: true,
    isSearchable: false,
    name: name,
    placeholder: title,
    noOptionsMessage: () => ___EmotionJSX("p", null, "Keine weiteren Filter verf\xFCgbar"),
    options: options,
    formatOptionLabel: o => o.display_name,
    getOptionLabel: o => o.display_name,
    getOptionValue: o => o,
    onChange: values => onChangeFilter(values),
    isDisabled: options.length === 0,
    chakraStyles: {
      multiValue: provided => _objectSpread(_objectSpread({}, provided), {}, {
        bg: chakraTheme.colors.base['700'],
        color: readableColor(chakraTheme.colors.base['700'])
      }),
      placeholder: provided => _objectSpread(_objectSpread({}, provided), {}, {
        color: readableColor(chakraTheme.colors.base['500'])
      }),
      menuList: provided => _objectSpread(_objectSpread({}, provided), {}, {
        bg: 'var(--chakra-colors-base-500)'
      }),
      option: provided => _objectSpread(_objectSpread({}, provided), {}, {
        color: readableColor(chakraTheme.colors.base['500']),
        bg: chakraTheme.colors.base['500'],
        '&:hover': {
          bg: chakraTheme.colors.base['700']
        }
      }),
      dropdownIndicator: provided => _objectSpread(_objectSpread({}, provided), {}, {
        bg: 'transparent',
        px: 2,
        cursor: 'inherit'
      }),
      indicatorSeparator: provided => _objectSpread(_objectSpread({}, provided), {}, {
        display: 'none'
      })
    }
  });
};
export default MultiSelect;